(function () {
  const STORAGE_KEY = 'cpr:recently-viewed';
  const section = document.querySelector('[data-recently-viewed]');
  if (!section) return;

  const container = section.querySelector('[data-recently-viewed-container]');
  const clearBtn  = section.querySelector('[data-recently-viewed-clear]');
  const limit     = parseInt(section.dataset.productsToShow, 10) || 4;
  const currentHandle = (location.pathname.match(/\/products\/([^/?]+)/) || [])[1];

  let handles = [];
  try { handles = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) {}
  handles = handles.filter(h => h && h !== currentHandle).slice(0, limit);

  if (!handles.length) { section.style.display = 'none'; return; }
  if (clearBtn) clearBtn.hidden = false;

  Promise.all(handles.map(h =>
    fetch(`/products/${h}?view=card`).then(r => r.ok ? r.text() : '').catch(() => '')
  )).then(htmls => {
    htmls.forEach(html => {
      if (!html.trim()) return;
      const li = document.createElement('li');
      li.className = 'grid__item';
      li.innerHTML = html.trim();
      container.appendChild(li);
    });
    if (!container.children.length) section.style.display = 'none';
  });

  if (clearBtn) clearBtn.addEventListener('click', () => {
    localStorage.removeItem(STORAGE_KEY);
    section.style.display = 'none';
  });
})();